import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";

import { AuthService } from "app/shared/auth.service";
import { PrimeNGUtilService } from "app/shared/primeng.service";
import { UtilFns } from "app/shared/util-fns";

@Component({
  selector: "login",
  templateUrl: "./login.component.html",
  styleUrls: ["./auth-shell.scss"],
  encapsulation: ViewEncapsulation.None,

  standalone: false,
})
export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  error = "";
  success = "";
  working = false;

  /**
   * Constructor
   *
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _authService: AuthService,
    private _primeNGUtilService: PrimeNGUtilService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      email: ["", [Validators.required]], // , Validators.email]],
      password: ["", Validators.required],
      persist: [false],
    });
  }

  onSubmit() {
    this.error = "";
    const { email, password, persist } = this.loginForm.value;
    if (!this.working) {
      this.working = true;
      this._authService.login(email, password, persist).then(
        (_) => {
          this.error = null;
          // const user = this._authService.getUser();
          this.success = "Logged in";
          this.working = false;

          this._primeNGUtilService.setupNavigation();
        },
        (error) => {
          if (error.status === 0) {
            this.error = "Unable to contact server";
          } else if (error.status === 401) {
            this.error = error.error || "Invalid login name or password";
          } else {
            //   this._logger.log(error, 'error');
            this.error = UtilFns.getErrorMessage(error);
          }

          this.working = false;
        }
      );
    }
  }
}
